import React, { Component } from 'react';
import LongText from '../Utils/LongText';


class Philosophy extends Component {
  
render() {
    const { activeButton } = this.props;
    return (
       <div style={{ all: 'unset' }}>
            {activeButton === 'about6' && (
                <div className="about-right-section-page">
                    <h1>Philosophy</h1>
                    <div className="about-right-section-text">
                        <LongText maxLength={1} byParagraphs>
                            <p> 
                            We each have our own way of experiencing, embodying, and
                            expressing our transpersonal understanding. My own path is
                            that of one who does so through creativity, intuition, and
                            curiosity. I have a passion for creative exploration, to
                            discover new connections through the depths of the psyche. I
                            love the infinite variety of forms our imaginations are able
                            to make in this process. I believe through creative
                            exploration and expression we feel more alive. This
                            aliveness heals us. My goal through my career, calling,
                            vocation, and work is to advocate for the joy one can
                            experience when connecting to their imaginative faculties.
                            The joy imagination brings allows us to take a playful
                            attitude towards our lives. We discover new possibilities,
                            we discover more of ourselves, learning that we're capable
                            of much more than we ever could have imagined.
                            </p>
                            <p>
                            My philosophy is that we all deeply desire authenticity, a
                            feeling of being alive, and of wholeness. This drive
                            underlies all things, it is the natural pure will of our
                            being, and it is what we all long to be connected with. I
                            believe that we're each have a unique "blueprint" which by
                            connecting with, understanding, and expressing, moves us
                            towards a deeper relationship with this authentic self. We
                            all seek this relationship—conscious of it or not. This
                            search is borne out through our search for meaning, the
                            search for our "true" nature. It is what makes us human.
                            Transpersonal Psychology is a field that studies this
                            relationship. It's a field that transforms us as we study,
                            and we in turn, influence other's to transform as well. 
                            </p>
                        </LongText>
                    </div>
                </div>
            )}
    </div> 
    );
  }
}

export default Philosophy;